import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { getNativeContext } from '../helpers/get-native-context';
var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  delayTime: 0,
  maxDelayTime: 1
};
export var createDelayNodeConstructor = function createDelayNodeConstructor(createAudioParam, createDelayNodeRenderer, createNativeDelayNode, isNativeOfflineAudioContext, noneAudioDestinationNodeConstructor) {
  return (
    /*#__PURE__*/
    function (_noneAudioDestination) {
      _inherits(DelayNode, _noneAudioDestination);

      function DelayNode(context) {
        var _this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

        _classCallCheck(this, DelayNode);

        var nativeContext = getNativeContext(context);

        var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options);

        var nativeDelayNode = createNativeDelayNode(nativeContext, mergedOptions);
        var isOffline = isNativeOfflineAudioContext(nativeContext);
        var delayNodeRenderer = isOffline ? createDelayNodeRenderer(mergedOptions.maxDelayTime) : null;
        _this = _possibleConstructorReturn(this, _getPrototypeOf(DelayNode).call(this, context, 'passive', nativeDelayNode, delayNodeRenderer)); // @todo Edge does not export the correct values for maxValue and minValue.

        _this._delayTime = createAudioParam(_assertThisInitialized(_this), isOffline, nativeDelayNode.delayTime, mergedOptions.maxDelayTime, 0);
        return _this;
      }

      _createClass(DelayNode, [{
        key: "delayTime",
        get: function get() {
          return this._delayTime;
        }
      }]);

      return DelayNode;
    }(noneAudioDestinationNodeConstructor)
  );
};